import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

import { Section } from "shared/layout";
import Button from "shared/Button";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import TabActionBar from "shared/TabActionBar";

export default function AccessCodeModal({ onClose, name, accessCode }) {
  return (
    <div>
      <Section className={styles.section}>
        <TabActionBar>
          <header className={styles.tabActionBarHeader}>
            <h3>Access Code</h3>
            <div>
              &nbsp;
              <Button size="small" onClick={() => onClose()}>
                Close
              </Button>
            </div>
          </header>
        </TabActionBar>
      </Section>

      <Section>
        {accessCode === "ERROR" && (
        <AlertNotice icon={<Danger />} title="Error">
            <div className={styles.mb1}>
              An error was encountered retrieving the Access Code. Please try again. If the problem continues, please report this issue to QA. 
            </div>
        </AlertNotice>
        )}

        {accessCode != "ERROR" && (
        <div>
          <div className={styles.hi}>Hi {name},</div>          
          <div>Please enter this code to access DreamStream:</div>
          <div className={styles.accessCode}>
            {accessCode}
          </div>
        </div>)} 

      </Section>
    </div>
  );
}
